/**
 * these values match config.json
 */
export enum Application {
  Billing = 'Billing',
  Configuration = 'Configuration',
  CustomerCare = 'CustomerCare',
  Documentation = 'Documentation',
  Reporting = 'Reporting',
  RatingAndCharging = 'RatingAndCharging',
  Security = 'Security',
  Studio = 'ContentStudio',
  Workbench = 'Workbench'
}
